import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24ab4456&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=24ab4456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab4456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ab4456')) {
      api.createRecord('24ab4456', component.options)
    } else {
      api.reload('24ab4456', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=24ab4456&scoped=true&", function () {
      api.rerender('24ab4456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/keystore/index.vue"
export default component.exports